import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const ModalContent = styled('div')({
  backgroundColor: '#F4F5F7',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  [media('xs')]: {
    gap: 35
  },
  [media('lg')]: {
    paddingLeft: 35,
    paddingRight: 35,
    paddingBottom: 10,
    paddingTop: 10,
    gap: 27
  }
});

export default ModalContent;
